import data from "../../content/articles.json";
import React from 'react'


function Tags () {
    return (
        <div className="form-group col">
        <label htmlFor="tag">Select Tag</label>
        <select className="nice-select" name="tag" id="tag" placeholder="Select Tag">
        {
            data.tags.map((data,i) => (
                    <option key={i}>{data.tag}</option>
            ))
        }
        </select>
        </div>
    )
};
export default Tags;